import React, { useState, useEffect } from 'react';
import { utils, writeFile } from 'xlsx';
import { Form, Button, Container, Row, Col, Spinner , Alert} from 'react-bootstrap';

const Monitoring = () => {
    const [servers, setServers] = useState([]);
    const [selectedServer, setSelectedServer] = useState(null);
    const [history, setHistory] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [loadingError, setLoadingError] = useState(false); // Nuevo estado para el mensaje de error

    // Obtener la lista de servidores al montar el componente
    useEffect(() => {
        fetch('https://radio.amgroupmkt.com:1030/api/v2/servers/')
            .then(response => response.json())
            .then(data => setServers(data))
            .catch(error => console.error('Error:', error));
    }, []);

    // Manejar la selección de un servidor
    const handleServerSelect = (event) => {
        const serverId = event.target.value;
        setSelectedServer(serverId);
        setIsLoading(true);
        setLoadingError(false); // Restablecer el estado de error

        const timeoutId = setTimeout(() => {
            if (isLoading) {
                setIsLoading(false);
                setLoadingError(true); // Mostrar mensaje de error si pasan 5 segundos
            }
        }, 5000); // Tiempo de espera de 5 segundos

        fetch(`https://radio.amgroupmkt.com:1030/api/v2/history/?limit=3000&server=${serverId}`)
            .then(response => response.json())
            .then(data => {
                clearTimeout(timeoutId); // Limpia el tiempo de espera si la carga es exitosa
                setHistory(data.results);
                setIsLoading(false);
            })
            .catch(error => {
                clearTimeout(timeoutId); // Limpia el tiempo de espera si ocurre un error
                console.error('Error:', error);
                setIsLoading(false);
                setLoadingError(true); // Establecer el estado de error debido a una falla en la carga
            });
    };

    const convertTimestampToDateAndTime = (timestamp) => {
        const date = new Date(timestamp);
        const formattedDate = date.toLocaleDateString("es-ES", {
            year: 'numeric', month: '2-digit', day: '2-digit'
        });
        const formattedTime = date.toLocaleTimeString("es-ES", {
            hour: '2-digit', minute: '2-digit', second: '2-digit'
        });
    
        return { formattedDate, formattedTime };
    };
    
    const translateHeaders = (history) => {
        return history.map(item => {
            const { formattedDate, formattedTime } = convertTimestampToDateAndTime(item.ts);
            return {
                "Id": item.id,
                "URL de Imagen": item.img_url || 'N/A',
                "Fecha": formattedDate,
                "Hora": formattedTime,
                "Metadatos": item.metadata || 'N/A',
                "Autor": item.author || 'N/A',
                "Título": item.title || 'N/A',
                "Género": item.genre || 'N/A',
                "Tipo de Actuación": item.performance_type || 'N/A',
                "Letrista": item.lyricist || 'N/A',
                "Compositor": item.composer || 'N/A',
                "Editor": item.publisher || 'N/A',
                "Etiqueta": item.label || 'N/A',
                "Título de la Lista de Reproducción": item.playlist_title || 'N/A',
                "Nombre del DJ": item.dj_name || 'N/A',
                "Número de Oyentes": item.n_listeners || 'N/A',
                "Duración": item.length || 'N/A',
                // ... agregar más campos si son necesarios ...
            };
        });
    };

    // Función para descargar el historial en formato Excel

    const convertDuration = (duration) => {
        const seconds = Math.floor(duration / 1000);
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}m ${remainingSeconds}s`;
    };
    
    const downloadExcel = () => {
        const serverName = servers.find(server => server.id.toString() === selectedServer)?.title || 'radio';
        const currentDate = new Date();
        const formattedDate = currentDate.toISOString().split('T')[0].replace(/-/g, '');
    
        const dataForExcel = history.map(item => {
            const { formattedDate, formattedTime } = convertTimestampToDateAndTime(item.ts);
            const readableDuration = convertDuration(item.length);
            return {
                "Id": item.id,
                "Fecha": formattedDate,
                "Hora": formattedTime,
                "Duración": readableDuration || 'N/A',
                "Número de Oyentes": item.n_listeners || 'N/A',
                "Metadatos": item.metadata || 'N/A',
                "URL de Imagen": item.img_url || 'N/A',
                "Autor": item.author || 'N/A',
                "Título": item.title || 'N/A',
                "Género": item.genre || 'N/A',
                "Tipo de Actuación": item.performance_type || 'N/A',
                "Letrista": item.lyricist || 'N/A',
                "Compositor": item.composer || 'N/A',
                "Editor": item.publisher || 'N/A',
                "Etiqueta": item.label || 'N/A',
                "Título de la Lista de Reproducción": item.playlist_title || 'N/A',
                "Nombre del DJ": item.dj_name || 'N/A',
                
                
                // ... agregar más campos si son necesarios ...
            };
        });
    
        const worksheet = utils.json_to_sheet(dataForExcel);
        const workbook = utils.book_new();
        utils.book_append_sheet(workbook, worksheet, 'Historial');
    
        // Construye el nombre del archivo con el formato especificado
        const fileName = `historial-${serverName}-${formattedDate}.xlsx`;
        writeFile(workbook, fileName);
    };

    return (
        <Container className="mt-5">
            <h1 className="text-center mb-4">Selector de Servidores de Radio</h1>
            <select onChange={handleServerSelect} value={selectedServer || ''} disabled={isLoading}>
                <option value="">Seleccione un servidor</option>
                {servers.map(server => (
                    <option key={server.id} value={server.id}>
                        {server.title}
                    </option>
                ))}
            </select>

            {loadingError && (
                <Alert variant="danger" className="mt-3">
                    Hubo un error al cargar el historial. Por favor, intente de nuevo.
                </Alert>
            )}

            {selectedServer && (
                <>
                    <h2 className="mt-4">Historial del Servidor: {selectedServer}</h2>
                    {/* Puede poner un spinner o algún indicador de carga aquí si isLoading es true */}
                    {isLoading ? (
                        <Spinner animation="border" role="status">
                            <span className="visually-hidden">Cargando...</span>
                        </Spinner>
                    ) : (
                        <Button 
                            variant="primary" 
                            onClick={downloadExcel}
                            disabled={history.length === 0 || isLoading} // Deshabilitar el botón si no hay historial o si se está cargando
                        >
                            Descargar Historial
                        </Button>
                    )}
                </>
            )}
        </Container>
    );
};

export default Monitoring;